import Spinner from '@carvana/ds-spinner';

export default function ComposerFilterLoadingIndicator() {
  return (
    <div
      className="flex w-full items-start gap-md"
      data-testid="composer-filter-loading-indicator"
    >
      <div className="flex h-[20px] items-center">
        <Spinner aria-hidden="true" size={16} />
      </div>
      <p className="flex-1 t-body-sm text-text-default">
        Applying filters and loading matches…
      </p>
    </div>
  );
}
